import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsAwardNewContentMocks: MicroMoments = {
  id: '',
  title: 'Award Travel Just Got More Rewarding',
  description:
    'Use your miles to book your next trip and still earn MQDs for that trip.',
  action: {
    label: 'Book With Miles',
    url: '/flight-search/book-a-flight'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/award-travel-mqd.svg',
    alt: 'Award Travel Logo'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
